import axios from "axios"
import { API_BASE_URL } from "../config"

// 型定義
export interface BulkImportData {
  estate: {
    name: string
    address: string
    phone: string
    accounts: { name: string; mail: string }[]
  }
  facilities: {
    name: string
    address: string
    phone: string
    building_type: number
  }[]
  residents: {
    facility_name: string
    room_no: string
    name: string
    initial: string
    birthday: number
    phone: string
    serials: string[]
    places: string[]
  }[]
}

export const manageBulkImport = async (data: BulkImportData) => {
  const requestData = {
    session_code: localStorage.getItem("session_code"),
    ...data
  }

  // 既存の作法に合わせた3回リトライ処理
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/bulk_import/create`, requestData)
      console.log(response.data)

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code === "ERR_NETWORK" && i !== 2) {
        continue
      }
      throw error
    }
  }
}
